import { DataSource } from "@mcleod/components";
import { AutogenLayoutProcessCommissionsPostExceptionTable } from "./autogen/AutogenLayoutProcessCommissionsPostExceptionTable";
import { CommissionsException } from "./ProcessCommissionsExceptionTable";
import { ModelRow } from "@mcleod/core";

export class ProcessCommissionsPostExceptionTable extends AutogenLayoutProcessCommissionsPostExceptionTable {



    public addWarningsAndExceptions(exceptions: CommissionsException[]) {
            this.tableExceptions.dataSource = new DataSource();
            exceptions.forEach(exception => {
                const newRowData = new ModelRow("", false);
                if (newRowData != null) {
                    newRowData.set("payee_id", exception.payee_id);
                    newRowData.set("deduct_code", exception.deduct_code);
                    newRowData.set("exception_message", exception.exception_message);
                    newRowData.set("commissions_ids", exception.commissions_ids);
                    newRowData.set("payee_name", exception.payee_name);
                    newRowData.set("order_id", exception.order_id);
                    newRowData.set("movement_id", exception.movement_id);
                    this.tableExceptions.addRow(newRowData, null, { display: true, addToData: true });
                }
            });
        }
}
